import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useCatalog } from "../hooks/useCatalog";
import { useAuth } from "./AuthContext";
import { UnlockModal } from "./UnlockModal";
import { CatalogDataProvider } from "./CatalogDataContext";
import { CompareProvider } from "./CompareContext";
import { StatusDot } from "./ui/StatusDot";

export function Layout() {
  const catalog = useCatalog();
  const { unlocked, loading } = useAuth();
  const [unlockOpen, setUnlockOpen] = useState(false);
  const scrapeAt = catalog.meta.lastPriceScrapeAt ?? catalog.meta.lastRefreshAt;
  const refreshLabel = scrapeAt
    ? new Date(scrapeAt).toLocaleString("en-IN", {
        timeZone: "Asia/Calcutta",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }) + " IST"
    : null;

  return (
    <CatalogDataProvider value={catalog}>
      <CompareProvider>
      <div className="app-shell">
        <header className="topbar">
          <div className="topbar-inner">
            <NavLink to="/" className="brand">
              <img src="/brand-mark.png" alt="" className="brand-mark" width={28} height={28} />
              <span className="brand-text">
                ModelMeter
                <small>API TRACKER</small>
              </span>
            </NavLink>
            <nav className="nav">
              <NavLink to="/" end>
                Catalog
              </NavLink>
              <NavLink to="/providers">Providers</NavLink>
              <NavLink to="/about">About</NavLink>
              {unlocked ? <NavLink to="/admin">Admin</NavLink> : null}
            </nav>
            <div className="topbar-meta">
              <StatusDot kind="live" className="mr-3 hidden sm:inline-flex" />
              {catalog.providers.length} providers · {catalog.models.length} models ·{" "}
              {catalog.meta.lastUpdated}
              {refreshLabel ? ` · prices ${refreshLabel}` : ""}
            </div>
            <button
              type="button"
              className={`btn-icon unlock-btn${unlocked ? " unlocked" : ""}`}
              aria-label={unlocked ? "Admin unlocked" : "Unlock admin"}
              title={unlocked ? "Admin unlocked" : "Unlock admin"}
              disabled={loading}
              onClick={() => setUnlockOpen(true)}
            >
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
                {unlocked ? (
                  <>
                    <rect x="5" y="11" width="14" height="10" rx="0" />
                    <path d="M8 11V8a4 4 0 0 1 8 0" />
                  </>
                ) : (
                  <>
                    <rect x="5" y="11" width="14" height="10" rx="0" />
                    <path d="M8 11V8a4 4 0 0 1 7.5-1.5" />
                  </>
                )}
              </svg>
            </button>
          </div>
        </header>
        <main className="main">
          <Outlet />
        </main>
        <footer className="footer">
          Public catalog · not affiliated · verify official docs · caveats are samples, not benchmarks
        </footer>
        <UnlockModal open={unlockOpen} onClose={() => setUnlockOpen(false)} />
      </div>
      </CompareProvider>
    </CatalogDataProvider>
  );
}
